<template>
  <div class="animated fadeIn list-of-tranbank">
    <b-card>
      <div slot="header">
        Request of Payment(ROP) List
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="addPayment">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</b-button>
          <!-- <b-button variant="primary mr-1" @click="approvalConfirm()"><i class="fa fa-paper-plane"></i> Approval</b-button>
          <b-button variant="btn btn-primary mr-1"  @click="posting" :disabled="(model.poststatus == 1)">posting</b-button> -->
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</button>
          <button class="btn btn-primary mr-1" @click="close()"><i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Description</label></b-input-group-prepend>
            <b-form-input v-model="tblData.uraian" style="width: 25% !important"></b-form-input>
            <b-input-group-prepend><span class="p-1">To/From</span></b-input-group-prepend>
            <b-form-input v-model="tblData.terimadari" placeholder="Pay to/Receipt from"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
            <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
            <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
            <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Trx. Date</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" style="width: 28% !important"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date" style="width: 28% !important"></b-form-input>
            <b-form-select v-model="tblData.poststatus" :plain="true" class="ml-1" :options="postingStatus"></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-row>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend><label>Trx. Number</label></b-input-group-prepend>
                <b-form-input v-model="tblData.nomor" placeholder="nomor (% for wildcard)"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend><span class="pt-2">Cheque/Giro# &nbsp;</span></b-input-group-prepend>
                <b-form-input v-model="tblData.paymethod" placeholder="Payment Method"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend><label>Cash/bank Account</label></b-input-group-prepend>
            <b-form-input v-model="tblData.namaacc" @change="tblData.kodebank = ''" placeholder="Finance Bank Code"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuBankaccountShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-form-input v-model="tblData.kodeacc" placeholder="Accounting Code" class="ml-1"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Pay/Receipt Group</label></b-input-group-prepend>
            <b-form-select v-model="tblData.trxgroup" :plain="true" :options="trxgroups" style="width: 25% !important"></b-form-select>
            <b-form-select v-model="tblData.iogroup" :plain="true" :options="['', 'All Payment', 'All Receipt']" class="ml-1"></b-form-select>
            <b-input-group-append>
              <b-button class="btn btn-success ml-3" @click="search()"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()"> <i class="fa fa-eraser"></i>Clear Filter</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(action)="data">
          <b-dropdown dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret size="sm" style="margin: -10px">
            <template v-slot:button-content>
              <i class="fa fa-play text-primary"></i>
            </template>
            <b-dropdown-item @click="rowEdit(data.item)" href="#"><span v-if="data.item.send2wf == 1">View</span><span v-else>Edit</span> </b-dropdown-item>
            <b-dropdown-item @click="rowApproval(data.item)" href="#">Approval</b-dropdown-item>
            <b-dropdown-item @click="rowPost(data.item)" href="#" v-if="data.item.issuccess == 1">Posting</b-dropdown-item>
            <b-dropdown-item @click="rowPrint(data.item)" href="#">Print Form</b-dropdown-item>
            <b-dropdown-item @click="rowDel(data.item)" href="#" :disabled="data.item.poststatus == 1"> Delete</b-dropdown-item>
          </b-dropdown>
        </template>
        <template v-slot:cell(nomor)="data">
          <div v-if="data.item.poststatus == 0 && data.item.issuccess == 1" style="background-color: yellow">{{ data.item.nomor }}</div>
          <div v-else>{{ data.item.nomor }}</div>
        </template>
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(original)="data">
          {{ data.item.valas_out | numFormat("0,0.00") }}
        </template>
        <template v-slot:cell(bank_out)="data">
          {{ data.item.bank_out | numFormat("0,0.00") }}
        </template>
        <template v-slot:cell(issuccess)="data">
          <status-aprroval :dataStatus="data.item"></status-aprroval>
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-1">
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to <span v-if="tblData.page * tblData.limit > tblData.total">{{ tblData.total }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="5">
          <b-input-group>
            <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend>
            <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>
            <b-pagination v-if="pagination" :total-rows="tblData.total" :per-page="tblData.limit" v-model="tblData.page"></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3">
          <div class="text-right pt-1">
            <span style="background-color: yellow">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-2">Record Not Posted</span>
          </div>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" scrollable size="xl" title="Preview as PDF" hide-footer>
      <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
      <b-row class="justify-content-center mt-1">
        <b-button variant="primary" v-if="isprintjv == true" @click.stop="editjv">Edit Journal</b-button>
        <b-button variant="secondary" class="ml-2" @click="showReport = false"> Close</b-button>
      </b-row>
    </b-modal>
    <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
      <lku-bankaccount @click="onSelectLkuBankaccount" :formdata="lkuBankaccountData"></lku-bankaccount>
    </b-modal>
    <b-modal v-model="showApprovalConfirm" header-bg-variant="primary" title="Approval Form" size="lg" :centered="true" hide-footer>
      <b-row>
        <b-col md="5">
          <b-input-group>
            <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
            <b-form-input v-model="model.nomor" readonly></b-form-input>
          </b-input-group>
        </b-col>
        <b-col md="4">
          <b-input-group>
            <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
            <b-form-input :value="model.tanggal | moment('DD MMM YYYY')" readonly></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-input-group>
        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
        <b-form-input v-model="model.uraian" readonly></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend><label>Payment To</label></b-input-group-prepend>
        <b-form-input v-model="model.terimadari" readonly></b-form-input>
      </b-input-group>

      <b-row>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend><label>Cash/bank Account</label></b-input-group-prepend>
            <b-form-input readonly v-model="model.namabank"></b-form-input>
            <b-input-group-append>
              <span class="input-group-text" style="width: 70px">{{ model.matauang }}</span>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col lg="5" v-if="model.jenis != 'Tunai'">
          <b-input-group>
            <b-input-group-prepend class="d-md-inline d-lg-none"><label>Bank Account No.</label></b-input-group-prepend>
            <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Bank Account#</span></b-input-group-prepend>
            <b-form-input disabled v-model="model.nomorrek"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend><label>Trx. Amount</label></b-input-group-prepend>
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{ model.matauang }}</span></b-input-group-prepend
            >
            <b-form-input :value="model.valas_out | numFormat" readonly class="text-right"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend
              ><label>Exch. Rate {{ model.matauang || "" }}</label></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{ uanguser }}</span></b-input-group-prepend
            >
            <b-form-input :value="model.kurstrx | numFormat" readonly class="text-right"></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>

      <div v-if="this.model.send2wf == 1">
        <label>Workflow process history</label>
        <div class="report-wraper">
          <table width="100%">
            <thead>
              <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th>Comment</th>
                <th width="120px">Complete Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                <td>{{ row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}</td>
                <td>{{ row.crewnik }} | {{ row.crewname }}</td>
                <td>
                  {{ row.actiontake }}
                  <p v-if="row.crewname !== row.actionBy">{{ row.actionBy }}</p>
                </td>
                <td>{{ row.message }}</td>
                <td>
                  <span v-if="row.completeddate">{{ row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss") }}</span>
                </td>
              </tr>
              <tr>
                <td colspan="5" class="subtotal"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <b-row class="justify-content-center mt-1">
          <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
          <b-button variant="danger" class="ml-1" v-if="model.iscomplete == 0 || model.isreject == 1 || approvalHistory.length == 0" @click="showApprovalCancelConfirm = true">
            <i class="fa fa-undo"></i> Cancel Approval</b-button
          >
          <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm = false"> <i class="fa fa-close"></i> Close</b-button>
        </b-row>
      </div>
      <div no-body v-else>
        <label>Add Attachment</label>
        <b-form-file v-model="file" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."></b-form-file>
        <div class="mt-3">
          Selected file: <strong>{{ file ? file.name : "" }}</strong>
        </div>
        <b-row class="justify-content-center mt-1" v-if="showConfirmNoFile">
          <label style="width: 260px !important">Send without attachment, are you sure?</label>
          <b-form-radio-group v-model="confirmNoFile" class="ml-1">
            <b-form-radio :value="true">Yes</b-form-radio>
            <b-form-radio :value="false">No</b-form-radio>
          </b-form-radio-group>
        </b-row>
        <b-row class="justify-content-center mt-1">
          <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
          <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm = false"> <i class="fa fa-close"></i> Close</b-button>
        </b-row>
      </div>
    </b-modal>
    <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
      <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
    </b-modal>
    <b-modal v-model="actionHistoryShow" header-bg-variant="primary" title="Action History" size="lg" :centered="true" ok-only>
      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Purchase Req. No.</label></b-input-group-prepend>
            <b-form-input v-model="model.requestno" readonly></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Request Date</label></b-input-group-prepend>
            <b-form-input v-model="model.requestdate" disabled></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <b-input-group>
        <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
        <b-form-input v-model="model.remark" readonly></b-form-input>
      </b-input-group>
      <div class="report-wraper">
        <table width="100%">
          <thead>
            <tr>
              <th width="120px">Action Date</th>
              <th>Comment</th>
              <th width="100px">Action By</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in actionHistory" :key="row.reqactionkey">
              <td>{{ row.actiondate | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}</td>
              <td>{{ row.actiondtl }}</td>
              <td>{{ row.actionby }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
    <b-modal v-model="showAttachment" header-bg-variant="primary" title="PR Attachment" size="lg" :centered="true" ok-only>
      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Requesition(PR)No.</label></b-input-group-prepend>
            <b-form-input v-model="model.requestno" readonly></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <div class="report-wraper">
        <table width="100%">
          <thead>
            <tr>
              <th width="200px">Attached Date</th>
              <th>File Name</th>
              <th width="100px">Attached By</th>
              <th width="40px">action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in attachmens" :key="row.attachmentKey">
              <td>{{ row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}</td>
              <td>
                <b-link @click="attachmentDownload(row)">{{ row.attchFileNm }}</b-link>
              </td>
              <td>{{ row.createby }}</td>
              <td>
                <div class="text-center" v-if="model.iscomplete == 0">
                  <a href="javascript:void(0)" class="text-danger" @click="delAttachment(row)">
                    <i class="fa fa-trash"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div no-body v-if="model.iscomplete == 0">
        <label>Add Attachment</label>
        <b-form-file v-model="file" placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."></b-form-file>
        <b-row class="mt-1">
          <span class="p-2"
            >Selected file: <strong>{{ file ? file.name : "" }}</strong></span
          >
          <b-button variant="success" @click="attachmentSave" class="sm" v-if="file"><i class="fa fa-paperclip"></i> Add Attachment</b-button>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-tranbank {
  table {
    td:nth-child(1) {
      width: auto;
    }
    td:nth-child(2) {
      width: auto;
    }
    td {
      .dropdown-item {
        padding: 0.1rem 1.5rem !important;
        font-size: smaller !important;
      }
    }
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import toastr from "mini-toastr";
import rop from "../../apis/rop";
import task from "../../apis/task";
import lkuBankaccount from "../lookup/lkuBankaccountLazzy";
import { validationMixin } from "vuelidate";
import { email } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, lkuBankaccount },
  mixins: [validationMixin],
  validations: {
    vendorEmail: {
      recepient: { email },
    },
  },
  data() {
    return {
      actionHistoryShow: false,
      actionHistory: [],
      showAttachment: false,
      attachmens: [],
      showApprovalConfirm: false,
      approvalHistory: [],
      file: null,
      confirmNoFile: false,
      showConfirmNoFile: "",
      showApprovalCancelConfirm: false,
      uanguser: this.$store.state.user.matauang,
      showFilter: false,
      showDelConfirm: false,
      showVoidConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      lkuBankaccountData: {},
      lkuBankaccountShow: false,
      isLoading: false,
      showReport: false,
      isprintjv: false,
      reportUrl: null,
      model: {},
      vendorEmail: { recepient: "" },
      pagination: false,
      limit: 20,
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: moment().format("YYYY-MM-DD"),
        sortBy: "tanggal",
        sortDesc: true,
        DimCol: "",
        iogroup: "",
        trxgroup: "",
      },
      postingStatus: [
        { value: "1", text: "Posted" },
        { value: "0", text: "Not Posted" },
        { value: "", text: "-- All --" },
      ],
      trxgroups: [
        { value: "", text: "--- All ---" },
        { value: "AP Payment", text: "AP Payment" },
        { value: "Cash Advance Payment", text: "Cash Advance Payment" },
        { value: "Adv.Settlement-Addition", text: "Adv.Settlement-Excess Expense" },
        { value: "Expense Reimburs", text: "Expense Reimbursment Payment" },
        { value: "Transfer Inter Account", text: "Transfer Inter Account" },
        { value: "Other Payment", text: "Other Payment" },
      ],
    };
  },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "Action",
          thStyle: "width:40px",
          thClass: "text-center",
        },
        {
          key: "issuccess",
          label: "Approval Status",
          thStyle: "width:80px",
          sortable: true,
        },
        {
          key: "nomor",
          label: "Trx. Number",
          sortable: true,
        },
        {
          key: "namabank",
          label: "Cash/Bank Name",
          sortable: true,
        },
        {
          key: "kodeacc",
          label: "Acc. Code",
          thStyle: "width:50px",
          sortable: true,
        },
        {
          key: "tanggal",
          thStyle: "width:70px",
          label: "Trx. Date",
          sortable: true,
        },
        {
          key: "uraian",
          label: "Description",
          sortable: true,
        },
        {
          key: "terimadari",
          label: "Paid to",
          sortable: true,
        },
        {
          key: "paymethod",
          label: "Pay Method",
          sortable: true,
        },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "$,¥",
          sortable: true,
        },
        {
          key: "original",
          label: "Original Amt.",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "bank_out",
          label: `Credit (${this.uanguser})`,
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "createby",
          label: "Input By",
          thStyle: "width:80px",
          sortable: true,
        },
        {
          key: "nomorbk",
          label: "Nomor BK/KK",
          thStyle: "width:100px",
          sortable: true,
        },
      ];
      const dims = this.$store.state.dimension;
      for (let i = 0; i < dims.length; i += 1) {
        fields.push({
          key: `${dims[i].value}Txt`,
          // thStyle: "width:100px",
          label: dims[i].text,
          sortable: true,
        });
      }

      return fields;
    },
    invalidEmail() {
      this.$v.vendorEmail.$touch();
      return this.$v.vendorEmail.$invalid;
    },
  },
  watch: {
    dimCol: function (newval) {
      this.tblData.DimVal = "";
      this.tblData.DimValInfo = "";
      this.tblData.DimColInfo = this.dimension.find((d) => d.value === newval).text;
    },
    limit: function (newVal) {
      setTimeout(() => {
        if (this.limit == newVal) {
          this.tblData.limit = newVal;
        }
      }, 500);
    },
    "tblData.iogroup": function (newval) {
      if (newval) {
        this.tblData.trxgroup = "";
      }
    },
    "tblData.trxgroup": function (newval) {
      if (newval) {
        this.tblData.iogroup = "";
      }
    },
  },
  methods: {
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowApproval(record) {
      this.model = record;
      this.approvalConfirm();
    },
    rowVoid(record) {
      this.model = record;
      this.voidConfirm();
    },
    rowPost(record) {
      this.rowClicked(record);
      this.posting();
    },
    rowPrint(record) {
      this.rowClicked(record);
      this.print();
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    onSelectLkuBankaccount(lkuData) {
      this.lkuBankaccountData = lkuData;
      this.lkuBankaccountShow = false;
      this.tblData.kodebank = lkuData.selected.kode;
      this.tblData.matauang = lkuData.selected.matauang;
      this.tblData.namaacc = lkuData.selected.namabank;
      this.tblData.nomorrek = lkuData.selected.nomorrek;
      this.lkuBankaccountShow = false;
    },
    saveFilter() {
      const keys = ["uraian", "DimCol", "DimColInfo", "DimVal", "tgl1", "tgl2", "nomor", "terimadari", "kodeacc", "namaacc", "kodebank", "paymethod", "trxgroup", "iogroup", "poststatus"];
      let filtered = false;
      const trBanklist = {};
      for (const key in this.tblData) {
        if (keys.indexOf(key) >= 0 && this.tblData[key]) {
          filtered = true;
          trBanklist[key] = this.tblData[key];
        }
      }
      if (filtered === true) {
        trBanklist.page = this.tblData.page;
        trBanklist.limit = this.tblData.limit;
        trBanklist.sortBy = this.tblData.sortBy;
        trBanklist.sortDesc = this.tblData.sortDesc;
        const filter = this.$store.state.filter;
        filter.trBanklist = trBanklist;
        this.$store.commit("filter", filter);
      }
    },
    addPayment() {
      this.saveFilter();
      router.push("rop-form");
    },
    edit: function () {
      if (this.model.trbankkey) {
        this.saveFilter();
        router.push(`rop-form/${this.model.trbankkey}`);
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.model.trbankkey) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Delete!");
      }
    },
    deleteData: async function () {
      try {
        this.isLoading = true;
        await rop.remove(this.model);
        this.refresh();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    data: async function (ctx) {
      const tblOrder = { sortBy: this.tblData.sortBy, sortDesc: this.tblData.sortDesc };
      this.pagination = false;
      const filter = this.$store.state.filter;
      let filtered = false;
      for (var key in filter.trBanklist) {
        this.tblData[key] = filter.trBanklist[key];
        filtered = true;
      }
      if (filtered === true) {
        this.tblData.tgl1 = filter.trBanklist.tgl1 || "";
        this.tblData.tgl2 = filter.trBanklist.tgl2 || "";

        this.showFilter = filtered;
        delete filter.trBanklist;
        this.$store.commit("filter", filter);
        let autoRefresh = true;
        if (this.tblData.page == 1) {
          if (tblOrder.sortBy == this.tblData.sortBy && tblOrder.sortDesc == this.tblData.sortDesc) {
            autoRefresh = false;
          } else autoRefresh = true;
        }
        if (autoRefresh == false) {
          this.isLoading = true;
          this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
          try {
            const list = await rop.list(this.tblData);
            this.pagination = true;
            this.isLoading = false;
            return list;
          } catch (error) {
            this.isLoading = false;
            if (error.sql) {
              toastr.error(error.sql, "ERROR MESSAGE", 10000);
            } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
            } else if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
        }
      } else {
        this.isLoading = true;
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        try {
          const list = await rop.list(this.tblData);
          this.pagination = true;
          this.isLoading = false;
          return list;
        } catch (error) {
          this.isLoading = false;
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page = 1;
      this.refresh();
    },
    clearFilter(ctx) {
      this.tblData.kodebank = "";
      this.tblData.kodeacc = "";
      this.tblData.namaacc = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.terimadari = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.DimVal = "";
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    posting: async function () {
      if (this.model.trbankkey) {
        if ((this.model.poststatus || 0) == 0) {
          this.showPostingConfirm = true;
        }
        if (this.model.poststatus == 1) {
          this.showUnpostConfirm = true;
        }
      } else {
        toastr.warn("Please select a row that want to be Posted!");
      }
    },
    postingData: async function () {
      this.isLoading = true;
      try {
        if (this.model.bank_out != 0) {
          await rop.postingPayment(this.model);
        } else {
          await rop.postingReceipt(this.model);
        }
        this.model.poststatus = 1;
        this.printjv();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    unpostData: async function () {
      this.isLoading = true;
      try {
        await rop.postingUndo(this.model);
        this.model.poststatus = 0;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    print: async function () {
      if (this.model.trbankkey) {
        try {
          this.reportUrl = null; this.showReport = true;
          this.reportUrl = await rop.print(this.model);
          this.isprintjv = false;
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    exportxls: async function () {
      this.isLoading = true;
      try {
        const response = await rop.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    showActionHistory: async function (record) {
      try {
        this.model = record;
        this.isLoading = true;
        const data = await rop.actionhistory(record);
        this.actionHistory = data;
        this.actionHistoryShow = true;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    getAttachment: async function (record) {
      try {
        this.model = record;
        this.isLoading = true;
        const data = await task.getAttachment({ taskkey: record.trbankkey });
        this.attachmens = data;
        this.showAttachment = true;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    attachmentSave: async function (evt) {
      evt.preventDefault();
      if (this.invalidFile) {
        console.log("validation : ", this.$v.file);
        console.log("model : ", this.file);
        //   this.showAddAttachment=true;
        toastr.error("Please choose a file");
      } else {
        toastr.info(`Attachment Save`);
        this.isLoading = true;
        try {
          const formData = new FormData();
          formData.append("file", this.file);
          formData.append("filename", this.file.name);
          formData.append("tablekey", this.model.trbankkey);
          formData.append("tableName", "rop");
          const response = await task.attachmentSave(formData);
          console.log("response : ", response);
          const data = await task.getAttachment({ taskkey: this.model.trbankkey });
          this.attachmens = data;
          this.file = null;
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    attachmentDownload: async function (fl) {
      this.isLoading = true;
      try {
        const response = await task.attachmentDownload(fl);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    delAttachment: async function (obj) {
      const pesan = `Do You realy want to delete the attachment "${obj.attchFileNm}"?`;
      this.$bvModal
        .msgBoxConfirm(pesan, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value == true) {
            this.isLoading = true;
            try {
              await task.delAttachment(obj);
              const data = await task.getAttachment({ taskkey: this.model.trbankkey });
              this.attachmens = data;
              this.isLoading = false;
            } catch (error) {
              this.isLoading = false;
              console.log("error : ", error);
              if (error.sql) {
                toastr.error(error.sql, "ERROR MESSAGE", 10000);
              } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
              } else if (error.message) {
                toastr.error(error.message, "ERROR MESSAGE", 10000);
              } else {
                toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
              }
            }
          }
          // this.close();
        })
        .catch((err) => {
          // An error occurred
        });
    },
    approvalConfirm: async function () {
      if (this.model.trbankkey) {
        if (this.model.send2wf == 1) {
          try {
            const data = await task.approvalhistory({ key: this.model.trbankkey });
            this.approvalHistory = data;
          } catch (error) {
            console.log("error : ", error);
            if (error.sql) {
              toastr.error(error.sql, "ERROR MESSAGE", 10000);
            } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
            } else if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
        }
        this.model.requestdate = this.model.requestdate ? moment(this.model.requestdate).format("YYYY-MM-DD") : "";
        this.showApprovalConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be sent to workflow Approval!");
      }
    },
    approval: async function (evt) {
      evt.preventDefault();
      try {
        const formData = new FormData();
        if (!this.file) {
          if (this.confirmNoFile == false) {
            toastr.info("Send without attachment, are you sure?");
            this.showConfirmNoFile = true;
            return;
          }
        } else {
          formData.append("file", this.file);
          formData.append("filename", this.file.name);
        }
        formData.append("tablekey", this.model.trbankkey);
        this.showApprovalConfirm = false;
        this.isLoading = true;
        const resp = await rop.approval(formData);
        this.model.send2wf = 1;
        this.refresh();
        this.isLoading = false;
        if (resp.message) {
          toastr.warn(resp.message, "warning", 10000);
        }
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    approvalUndo: async function () {
      this.isLoading = true;
      try {
        await rop.approvalUndo(this.model);
        this.model.send2wf = 0;
        this.showApprovalConfirm = false;
        this.refresh();
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    printApproval: async function () {
      if (this.model.trbankkey) {
        this.isLoading = true;
        try {
          this.reportUrl = null; this.showReport = true;
          this.reportUrl = await task.approvalprint({ key: this.model.trbankkey });
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },

    close() {
      router.push("/treasury/home");
    },
  },
};
</script>
